import React, { Component } from 'react';
import { Spring, animated } from 'react-spring';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import SpritesheetAnim from '../../components/SpritesheetAnim';
import SurferSpriteSheet from '../../assets/sea/surfer-row.png';

import { surferConfigs } from '../../constants/spriteConfigs';

import './styles.css';

const propTypes = {
  speedValues: PropTypes.oneOfType([PropTypes.object]),
  scrollPos: PropTypes.number,
  shouldCharMove: PropTypes.func.isRequired,
  move: PropTypes.string.isRequired,
  width: PropTypes.number,
};

const defaultProps = {
  speedValues: {},
  scrollPos: 0,
  width: undefined,
};

export default class Sea extends Component {
  constructor(props) {
    super(props);

    this.boatPos = 0;
    this.island = false;
    this.sea = false;

    this.state = {
      stopBoat: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      scrollPos, shouldCharMove, speedValues, width,
    } = this.props;
    const minBoatVal = isMobile ? 12700 : 12300;
    const maxBoatVal = isMobile ? 15780 : 15400;
    const alignBoatVal = isMobile ? 12800 : 12330;

    if (prevProps.scrollPos !== scrollPos) {
      shouldCharMove(true);
      this.updateBoatPos(scrollPos, 0);

      if (Math.abs(speedValues.fast) < minBoatVal) {
        if (this.sea) {
          this.continueBoatParallax();
        }
      }

      if (Math.abs(speedValues.fast) > maxBoatVal) {
        this.updateBoatPos(scrollPos, 3000);
        if (this.sea) {
          this.continueBoatParallax();
        }
      }

      if (
        Math.abs(speedValues.fast) > minBoatVal
        && Math.abs(speedValues.fast) < maxBoatVal
      ) {
        if (Math.abs(speedValues.fast) !== alignBoatVal) {
          if (!isMobile) {
            const midVal = (window.innerWidth / 2) - 960;
            const adjustBoatMid = alignBoatVal - Math.round(midVal);

            document.getElementsByClassName('boat-container')[0].style.transform = `translate3d(-${adjustBoatMid}px, 0px, 0px)`;
            document.getElementsByClassName('boat-container')[1].style.transform = `translate3d(-${adjustBoatMid}px, 0px, 0px)`;
          } else {
            document.getElementsByClassName('boat-container')[0].style.transform = `translate3d(-${alignBoatVal}px, 0px, 0px)`;
            document.getElementsByClassName('boat-container')[1].style.transform = `translate3d(-${alignBoatVal}px, 0px, 0px)`;
          }
        }

        this.stopBoatParallax();
      }

      if (this.sea) {
        shouldCharMove(false);
      }
    }

    if (this.sea && width && !isMobile) {
      const midVal = (width / 2) - 960;
      const adjustBoatMid = alignBoatVal - Math.round(midVal);

      document.getElementsByClassName('boat-container')[0].style.transform = `translate3d(-${adjustBoatMid}px, 0px, 0px)`;
      document.getElementsByClassName('boat-container')[1].style.transform = `translate3d(-${adjustBoatMid}px, 0px, 0px)`;
    }
  }

  updateBoatPos = (scrollPos, diff) => {
    let pos = -(scrollPos * 0.4);

    if (diff > 0) {
      pos += diff;
    }

    this.boatPos = pos;
  };

  stopBoatParallax = () => {
    if (!this.sea) {
      this.setState({ stopBoat: true });
      this.sea = true;
    }
  };

  continueBoatParallax = () => {
    if (this.sea) {
      this.setState({ stopBoat: false });
      this.sea = false;
    }
  };

  render() {
    const {
      speedValues, scrollPos, move,
    } = this.props;
    const { stopBoat } = this.state;

    return (
      <div className="scenario-4">
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.slow, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-1"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="sky" />
              <div className="sun" />
              <div className="cloud-1" />
              <div className="cloud-2" />
              <div className="cloud-3" />
              <div className="cloud-4" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.normal, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-2"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="cloud-5" />
              <div className="cloud-6" />
              <div className="cloud-7" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.slow, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-3"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="background-trees" />
              <div className="palmtree-1" />
              <div className="palmtree-2" />
              <div className="back-wave" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.normal, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-4`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="palmtree-big-1" />
              <div className="palmtree-big-2" />
              <div className="palmtree-2" />
              <div className="hard-sec-sign" />
              <div className="mid-wave" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.fast, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-5`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="surfer-container">
                <SpritesheetAnim
                  ref={node => {
                    this.sprite = node;
                  }}
                  spritePath={SurferSpriteSheet}
                  spriteConfigs={surferConfigs}
                  loopAnim
                  moveLoopDirection={move}
                />
              </div>
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          cancel={stopBoat}
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [this.boatPos, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-6 boat-container`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="boat-sail" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          cancel={stopBoat}
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [this.boatPos, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-7 boat-container`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="boat" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.fast, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-8`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="front-wave" />
              <div className="bottom-sea-front-wave" />
            </animated.div>
          )}
        </Spring>
      </div>
    );
  }
}

Sea.propTypes = propTypes;
Sea.defaultProps = defaultProps;
